export default __webpack_public_path__ + "static/media/multiply.cb0b9a3d.svg";